export const DA = {
  "Open document": "Ãbn dokument",
  "Upload file": "Upload fil",
  "Drop file here to upload": "Drop filen her for at uploade",
  "Disc": "Disk",
  "URL": "URL",
  "FILE": "FIL",
  "SIZE": "STÃRRELSE",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "IndlÃ¦ser vent venligst.",
  "Fit Width": "Tilpas bredde",
  "Fit Height": "Tilpas hÃ¸jde",
  "Password protected document": "Adgangskodebeskyttet dokument",
  "Password": "Adgangskode",
  "Open": "Ãben",
  "Password Required": "Adgangskode pÃ¥krÃ¦vet",
  "Incorrect password": "forkert kodeord",
  "Error": "Fejl",
  "Something went wrong": "Noget gik galt",
  "Server is not available": "Serveren er ikke tilgÃ¦ngelig",
  "of": "af",
  "Please wait...": "Vent venligst..."
};
